import Head from "next/head";
import { useRouter } from "next/router";
import { appWithTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { MenuMobileProvider } from "../contexts/MenuMobileContext";
import { ThemeProvider } from "../contexts/ThemeContext";
import "../styles/globals.scss";
import "react-international-phone/style.css";
import "../styles/tailwind.css";
import { Toaster } from "react-hot-toast";
import nextI18nextConfig from "../../next-i18next.config";
import { theme } from "../styles/theme";

const SITE_ORIGIN = "https://www.verzel.com.br";

/** every routed page lives under /pt or /en with the same path shape, so the
 * language alternates are always the current path with the locale swapped */
function HreflangAlternates() {
	const router = useRouter();
	const path = router.asPath.split("#")[0].split("?")[0];
	const rest = path.replace(/^\/(pt|en)(?=\/|$)/, "");

	return (
		<Head>
			<link rel="alternate" hrefLang="pt" href={`${SITE_ORIGIN}/pt${rest}`} />
			<link rel="alternate" hrefLang="en" href={`${SITE_ORIGIN}/en${rest}`} />
			<link
				rel="alternate"
				hrefLang="x-default"
				href={`${SITE_ORIGIN}/pt${rest}`}
			/>
		</Head>
	);
}

function MyApp({ Component, pageProps }) {
	const router = useRouter();
	const [isHome, setIsHome] = useState(false);

	useEffect(() => {
		const handleRouteChange = (url) => {
			if (!process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS) {
				return;
			}

			if (typeof window !== "undefined") {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: "page_view",
					page_path: url,
				});
			}
		};

		if (router.pathname === "/") {
			setIsHome(true);
		} else {
			setIsHome(false);
		}

		router.events.on("routeChangeComplete", handleRouteChange);
		return () => {
			router.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router.pathname, router.events]);

	return (
		// <I18nextProvider i18n={i18n}>
		<ThemeProvider>
			<StyledThemeProvider theme={theme}>
				<MenuMobileProvider>
					<HreflangAlternates />
					<Toaster />
					<Component {...pageProps} />
				</MenuMobileProvider>
			</StyledThemeProvider>
		</ThemeProvider>
		// </I18nextProvider>
	);
}

export default appWithTranslation(MyApp, nextI18nextConfig);
